import { render, staticRenderFns } from "./MppFileFolder.vue?vue&type=template&id=e19c0e6c&scoped=true"
import script from "./MppFileFolder.vue?vue&type=script&lang=js"
export * from "./MppFileFolder.vue?vue&type=script&lang=js"
import style0 from "./MppFileFolder.vue?vue&type=style&index=0&id=e19c0e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19c0e6c",
  null
  
)

export default component.exports